export const settingsCharm_ariaLabel = "UBa";
export default {settingsCharm_ariaLabel};